export { default as ImageViewer } from '@components/imageViewer/ImageViewer';



// WEBPACK FOOTER //
// ./src/components/imageViewer/index.ts